function nativeErrorToJSON(error) {
  if (JSON.stringify(error) === "{}") {
    return {
      name: error.name,
      message: error.message,
      stack: error.stack,
      cause: error.cause instanceof Error ? nativeErrorToJSON(error.cause) : error.cause,
      errors: error instanceof AggregateError ? error.errors.map((innerError) => innerError instanceof Error ? nativeErrorToJSON(innerError) : innerError) : void 0
    };
  }
  return error;
}
function hasStack(error) {
  return typeof error === "object" && error !== null && "stack" in error;
}
function formatError(error) {
  return {
    stack: error.stack,
    cause: hasStack(error.cause) ? formatError(error.cause) : error.cause
  };
}

export { formatError, hasStack, nativeErrorToJSON };
//# sourceMappingURL=utils.js.map
